import styled from 'react-emotion'
import { themeGet as th } from 'styled-system'
import { Divider } from 'shared/ui'

export default styled(Divider)`
  &&& {
    margin-top: auto;
    margin-left: -16px;
    margin-right: -16px;
    border-top: 1px solid ${th('colors.ultraDust')};
    display: block !important;
  }
`
